import React from 'react';
//import { Link } from "react-scroll";

const AboutMeSection = () => {
  return (

<section className="section" id="aboutme">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 align-self-center">
                            <h5 className="fs-24 text-dark fw-medium"><mark>About Me</mark></h5>
                            <h4 className="fw-normal lh-base text-gray-700 mb-4 fs-20">                
                            <p align="justify">Manoj Mishra is an accomplished electronics engineer, entrepreneur, and project leader with over 16 years of experience in embedded systems, IoT, and automotive electronics. He is the Director of Quantalase Enterprises Pvt. Ltd., where he drives advanced product development and technology innovation, and also works as a Consultant with Nevaloss Technologies, supporting global clients in software–electronics integration.
</p><br></br>
<p align="justify">Over the years, Manoj has successfully delivered solutions for international automotive and industrial clients, including leading aftermarket companies in the USA. To strengthen his leadership and project management capabilities, he completed the Certificate Programme in Project Management (CPPM) at the Indian Institute of Management Indore (IIM Indore), making him a proud alumnus of one of India’s most prestigious management institutes.</p>

                            </h4>
                            <div className="social">
                            <a href="https://github.com/manoj8indore" target="_blank" rel="noopener noreferrer">
                            <i className="lab la-github github me-1"></i>
                            </a>

                            <a href="https://www.linkedin.com/in/manoj-mishra-9a534116/" target="_blank" rel="noopener noreferrer">
                             <i className="lab la-linkedin-in linkedin me-1"></i>
                            </a> 
                            </div>
                        </div>
                        <div className="col-lg-5 ms-auto align-self-center">
                            <div className="mb-5 mb-lg-0">
                                <p className="mb-2">
                                    <span className="personal-detail-title">Date of birth</span>
                                    <span className="personal-detail-info">25 Dec 1985</span>
                                </p>
                                <p className="mb-2">
                                    <span className="personal-detail-title">Spoken Languages</span>
                                    <span className="personal-detail-info">English - Hindi</span>
                                </p>
                                <p className="mb-2">
                                    <span className="personal-detail-title">Nationality</span>
                                    <span className="personal-detail-info">Indian</span>
                                </p>
                                <p className="mb-2">
                                    <span className="personal-detail-title">Interest</span>
                                    <span className="personal-detail-info">Reading, Listening Motivational Speakers</span>
                                </p>
                                <p className="mb-2">
                                    <span className="personal-detail-title">Passion</span>
                                    <span className="personal-detail-info">Programming</span>
                                </p>
                                <p className="mb-2">
                                    <span className="personal-detail-title">Hobby</span>
                                    <span className="personal-detail-info">Exercise and Reading</span>
                                </p>
                                <p className="mb-2">
                                    <span className="personal-detail-title">Likes</span>
                                    <span className="personal-detail-info">Exploring the healthy dishes</span>
                                </p>
                                <p className="mb-2">
                                    <span className="personal-detail-title">Purpose of Life</span>
                                    <span className="personal-detail-info">Exploring the Tech World</span>
                                </p>
                                
                            </div>
                        </div>
                        <div className="col-12 mt-5">
                            <div className="d-flex flex-wrap justify-content-center mt-4 mt-md-5">
                                {[
                                    { imgSrc: "assets/images/embeded-c.png", title: "Embedded C", experience: "16 Year Experience" },
                                    { imgSrc: "assets/images/c++.png", title: "C ++", experience: "16 Year Experience" },
                                    { imgSrc: "assets/images/c-sharp.png", title: "C-Sharp", experience: "14 Year Experience" },
                                    { imgSrc: "assets/images/C_Logo.png", title: "C", experience: "16 Year Experience" },
                                    { imgSrc: "assets/images/python.png", title: "Python", experience: "5 Year Experience" },
                                    { imgSrc: "assets/images/visual-studio.png", title: "Visual Studio", experience: "12 Year Experience" },
                                    { imgSrc: "assets/images/vb.png", title: "VB.NET", experience: "20 Year Experience" },
                                    { imgSrc: "assets/images/pcb-board.png", title: "PCB Designing", experience: "16 Year Experience" },
                                ].map((skill, index) => (
                                    <div key={index} className="mx-3 ms-sm-0 ms-sm-0 mb-3 card-bg rounded p-1 pe-3 p-md-3 pe-md-4 shadow-sm">
                                        <div className="d-flex align-items-center">
                                            <div className="thumb-md d-flex flex-wrap justify-content-center align-items-center">
                                                <img src={skill.imgSrc} alt="" height="40" />
                                            </div>
                                            <div className="ms-3">
                                                <h6 className="mb-0 fw-medium text-gray-700">{skill.title}</h6>
                                                <p className="text-muted mb-0 fs-12">{skill.experience}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            );
        };
    export default AboutMeSection;